import Vuetify from '@/plugins/vuetify';

Vuetify.framework.lang.current = (localStorage.getItem('idioma')) ? localStorage.getItem('idioma') : 'pt';

export default {
  filtros: {
    page: 1,
    perPage: 20,
    termo: '',
    referenciaCliente: '',
    codigoStatusEmbarque: [],
    nomeEmpresa: '',
    codigoProcesso: '',
    codigoFilial: '',
    referenciaProcesso: '',
    dataComissao: '',
    valorNota: '',
    icms: '',
    status: '',
    order: 'codigoProcesso',
    direcao: 'DESC',
  },
  campos: {
    nomeEmpresa: 'nomeEmpresa',
    codigoProcesso: 'codigoProcesso',
    codigoFilial: 'codigoFilial',
    referenciaProcesso: 'referenciaInterna',
    dataComissao: 'dataComissao',
    tipoImportacao: 'tipoImportacao',
    valorNota: 'valorNota',
    ICMS: 'valorIcms',
    status: 'status',
    valorComissao: 'valorComissao',
  },
  processosComissoes: [],
};
